export const Permissions = {
  create: "create:Component",
  read: "read:Component",
  list: "list:Component",
  update: "update:Component",
  delete: "delete:Component",
};
